import React from 'react';
import { Button } from 'react-bootstrap';
import "./PrimaryButton.scss"

const PrimaryButton = (props) => {
    const { onClick, disabled, text } = props;
    return (
        <Button className="primary-button create-btn-light" onClick={onClick} disabled={disabled}>
                {text}
        </Button>
    )
}

export default PrimaryButton;